<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            :color="message.error ? 'red' : 'green'">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.error || message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <div>
                  <div class="body-2 mb-2">
                    Periode
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. 2023"
  
                    :items="years"
                    :item-color="set_color"
  
                    v-model="filter.year"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
  
                <div>
                  <div class="body-2 mb-2">
                    Bulan
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. Januari"
  
                    :items="months"
                    item-text="text"
                    item-value="value"
                    :item-color="set_color"
  
                    v-model="filter.month"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
  
                <div v-if="dpa && dpa.perubahan_date && !isInPerubahanPeriod">
                  <div class="body-2 mb-2">
                    Status Anggaran
                  </div>
                  <div>
                    <v-autocomplete
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih DPA"
  
                      :items="['murni', 'p1']"
                      :item-color="set_color"
                      clearable
                      @click:clear="filter.dpa = ''"
  
                      v-model="filter.dpa"
                      required
                      class="mx-1"
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </div>
                </div>
  
                <div>
                  <div class="body-2 mb-2">
                    Pengecualian
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Pengecualian"
  
                    :items="[
                      { text: 'Dengan Pengecualian', value: '1' },
                      { text: 'Tanpa Pengecualian', value: '0' }
                    ]"
                    item-text="text"
                    item-value="value"
                    :item-color="set_color"
  
                    v-model="filter.is_pengecualian"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
  
                <!-- <div>
  
                  <div class="body-2 mb-2">
                    Pilih Filter
                  </div>
  
                  <v-autocomplete
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Pilih Filter"
  
                    :items="category"
                    :item-color="set_color"
                    v-on:change="filter.unit_id = ''; filter.asistensi = ''; filter.type = '';"
  
  
                    clearable
                    @click:clear="filter.category = ''"
  
                    v-model="filter.category"
                    required
                    class="mb-2"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div>
  
                <div v-if="filter.category === 'Gabungan'">
                  <div class="body-2 mb-2">
                    Pilih Filter Gabungan
                  </div>
  
                  <v-autocomplete
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Pilih Filter Gabungan"
  
                    :items="type"
                    :item-color="set_color"
  
                    clearable
                    @click:clear="filter.type = ''"
  
                    v-model="filter.type"
                    required
                    class="mb-2"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div>
  
                <div v-if="filter.type === 'Asisten'">
                  <div class="body-2 mb-2">
                    Asisten
                  </div>
  
                  <v-autocomplete
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. Asisten Administrasi Umum"
  
                    :items="asistensi"
                    :item-color="set_color"
  
                    hide-details
  
                    clearable
                    @click:clear="filter.asistensi = ''"
  
                    v-model="filter.asistensi"
                    required
                    class="mb-2"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div>
  
                <div v-if="filter.category === 'OPD'">
                  <div class="body-2 mb-2">
                    OPD
                  </div>
  
                  <v-autocomplete
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. Bagian Administrasi Pembangunan"
  
                    :items="filter_data.unit"
                    item-text="title"
                    item-value="id"
                    :item-color="set_color"
  
                    hide-details
  
                    clearable
                    @click:clear="filter.unit_id = ''"
  
                    v-model="filter.unit_id"
                    required
                    class="mb-3"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div>
  
                <div v-if="filter.type === 'Kecamatan'">
                  <div class="body-2 mb-2">
                    Kecamatan
                  </div>
  
                  <v-autocomplete
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. Kecamatan Klaten tengah"
  
                    :items="filter_data.kecamatan"
                    item-text="name"
                    item-value="id"
                    :item-color="set_color"
  
                    hide-details
  
                    clearable
                    @click:clear="filter.kecamatan_id = ''"
  
                    v-model="filter.kecamatan_id"
                    required
                    class="mb-2"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div> -->
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
            <v-row
              class="pa-4 pb-2 pr-1">
              <v-col
                cols="12">
                <v-card
                  flat
                  color="transparent">
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="30">
                        <v-img
                          contain
                          alt="kominfoklaten"  
                          :src="require('@/assets/image/grip_menu.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
  
                      <span
                        class="title black--text ml-2"
                        style="font-weight: 600;">
                        Rekapitulasi OPD Publik
                      </span>
                    </div>
  
                    <v-spacer />
  
                    <div>
                      
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              align="center"
              justify="end"
              class="pa-4 py-0 pr-1">
              <v-col
                cols="12"
                md="7">
                <div
                  class="body-2">
                  Periode 
  
                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>
  
                  <span v-if="filter.month !== '' && filter.month !== null">
                    bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
  
                  <span v-if="filter.type === 'Sekda' || filter.type === 'Dinas Pendidikan' || filter.type === 'Dinas Kesehatan'">
                    di gabungan <strong class="black--text">{{ filter.type }}</strong>
                  </span>
  
                  <span v-if="filter.asistensi !== '' && filter.asistensi !== null">
                    di asisten <strong class="black--text">{{ filter.asistensi }}</strong>
                  </span>
  
                  <span v-if="filter.unit_id !== '' && filter.unit_id !== null">
                    di unit <strong class="black--text">{{ filter.unit_title }}</strong>
                  </span>
  
                  <span v-if="filter.kecamatan_id !== '' && filter.kecamatan_id !== null">
                    di kecamatan <strong class="black--text">{{ filter.kecamatan_title }}</strong>
                  </span>
  
                  <span v-if="filter.is_pengecualian !== '' && filter.is_pengecualian !== null">
                    <strong class="black--text ml-1">{{ filter.is_pengecualian === '0' ? 'Tanpa Pengecualian' : 'Dengan Pengecualian' }}</strong>
                  </span>
                </div>
              </v-col>
  
              <v-col
                cols="12"
                md="5"
                class="d-flex align-center" style="justify-content: end;">
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="dialog.filter = true; fetchUnit();"
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-filter-multiple-outline</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Filter
                    </span>
                  </v-tooltip>
                </div>
  
                <div class="ml-3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click.stop="exportsExcel()"
                        :loading="process.exportExcel"
                        elevation="0"
                        dark
                        min-height="36"
                        small
                        min-width="36"
                        color="#216f45"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18" color="white">mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Export Excel
                    </span>
                  </v-tooltip>
                </div>
                
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click.stop="exports()"
                        :loading="process.export"
                        elevation="0"
                        dark
                        min-width="36"
                        color="#b40c1d"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Export Pdf
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <div class="view" v-if="!process.load">
                    <div class="wrapper">
                      <table style="border: 1px solid #ededed;" class="table">
                        <tr>
                          <th rowspan="2" class="sticky-col one-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 350px; width: 350px; max-width: 350px;">OPD</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Murni</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran P1</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Perubahan</th>
                          <th colspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Fisik</th>
                          <th colspan="4" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Keuangan</th>
                        </tr>
  
                        <tr>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Realisasi %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Target %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Deviasi %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px; text-align: right;">Anggaran Kas Perbulan ( Rp )</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Persentase SP2D terhadap Pagu Anggaran</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 220px; text-align: right;">Realisasi Keuangan/SP2D (Rp)</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Persentase SP2D terhadap Kas Perbulan</th>
                        </tr>
  
  
  
                        <tr v-for="(item, index) in list" :key="index">
                          <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                            <div :class="item.type === 'Program' ? 'font-weight-bold' : item.type === 'Kegiatan' ? '' : ''" :style="item.type === 'Kegiatan' ? 'font-weight: 600' : ''">
                              {{ item.unit_name }}
                            </div>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                              {{ listMurni[index]?.total_anggaran ?? 0 | price }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                              {{ item.total_anggaran_p1 | price }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                              {{ item.total_anggaran_perubahan | price }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                              {{ item.total_realisasi_fisik }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                              {{ item.total_target_fisik }}
                            
                          </td>
                          
                          <td :style="item.deviasi*1 <= -10? 'background: red' : item.deviasi*1 > 10 ? 'background: blue' : item.deviasi*1 <= 9.99 && item.deviasi*1 >= -2.99 ? 'background: green' : item.deviasi*1 <= -3.00 && item.deviasi*1 >= -5.99 ? 'background: yellow' : item.deviasi*1 <= -6.00 && item.deviasi*1 >= -9.99 ? 'background: orange' : '' " style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                              {{ item.deviasi }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                              {{ item.total_target_keu | price }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                              {{ item.persentase_sp2d }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                              {{ item.total_realisasi_keu | price }}
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                              {{ item.persentase_sp2d_anggaran }}
                            
                          </td>
                        </tr>
  
                        <tr v-if="Object.keys(detail).length > 0">
                          <td class="sticky-col one-col font-weight-bold text-center" style="font-size: 14px; border: 1px solid #ededed;padding: 8px 12px;">Jumlah</td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detailMurni?.grand_total_anggaran ?? 0 | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.grand_total_anggaran_p1 | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.grand_total_anggaran_perubahan | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.grand_total_realisasi_fisik }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.grand_total_total_target_fisik }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.grand_total_deviasi }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                           {{ detail.grand_total_target_keuangan | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.grand_total_persentase_sp2d }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.total_realisasi_keuangan | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.grand_total_persentase_sp2d_anggaran }}
                            
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import moment from "moment"
    import "moment/locale/id"
    import { generateRekapOpdPublicPdf } from "@/utils/export-rekap-opd-public-pdf"
    export default {
      data () {
        return {
          checkbox: false,
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false
          },
          detail: {},
  
          type: ['Asisten', 'Sekda', 'Dinas Pendidikan', 'Kecamatan', 'Dinas Kesehatan', 'Semua Kecamatan', 'Semua Kelurahan', 'Semua Puskesmas'],
  
          category: ['OPD', 'Gabungan'],
  
          asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],
          
          search: '',
  
          filter: {
            year: new Date().getFullYear(),
  
            month: 1,
            month_text: 'Januari',
  
            unit_id: '',
            unit_title: '',
            asistensi: '',
            kecamatan_id: '',
            kecamatan_title: '',
            type: '',
            category: '',
            is_pengecualian: '1',
            dpa: 'murni'
          },
  
          filter_data: {
            unit: [],
            kecamatan: [
              {
                name: 'KECAMATAN KLATEN TENGAH',
                id: '42,326,327,328,330,329,325'
              },
              {
                name: 'KECAMATAN KLATEN UTARA',
                id: '43,334,335'
              },
              {
                name: 'KECAMATAN KLATEN SELATAN',
                id: '41,313'
              },
              {
                name: 'KECAMATAN JATINOM',
                id: '32,179'
              }
            ]
          },
  
          listMurni: [],
          detailMurni: {},

          selected: {
            row: [],
            freeze: [],
            delete: []
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          process: {
            load: false,
  
            export: false,
            exportExcel: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
      },
      watch: {
        'options': {
          handler () {
            let pagination = { row: this.limit, page: 1 }
            
            this.fetch(pagination)
          },
          deep: true
        },
  
        'filter.year': function () {
          this.fetchDpa()
        },
  
        'filter.month': function () {
          let t = this
  
          let m = this.months.filter(function(v) {
            return t.filter.month == v.value
          })
  
          if (m.length > 0) {
            this.filter.month_text = m[0].text
          }
        },
  
        'filter.type': function () {
          let t = this
          t.filter.asistensi = ''
          t.filter.unit_id = ''
          t.filter.kecamatan_id = ''
        },
  
        'filter.asistensi': function () {
          let t = this
  
          t.filter.asistensi === null ? t.filter.asistensi = '' : ''
  
          // let u = this.filter_data.unit.filter(function(v) {
          //   return t.filter.unit_id == v.id
          // })
  
          // if (u.length > 0) {
          //   this.filter.unit_title = u[0].title
          // }
        },
  
        'filter.unit_id': function () {
          let t = this
  
          t.filter.unit_id === null ? t.filter.unit_id = '' : ''
  
          let u = this.filter_data.unit.filter(function(v) {
            return t.filter.unit_id == v.id
          })
  
          if (u.length > 0) {
            this.filter.unit_title = u[0].title
          }
        },
  
        'filter.kecamatan_id': function () {
          let t = this
  
          t.filter.kecamatan_id === null ? t.filter.kecamatan_id = '' : ''
  
          let u = this.filter_data.kecamatan.filter(function(v) {
            return t.filter.kecamatan_id == v.id
          })
  
          if (u.length > 0) {
            this.filter.kecamatan_title = u[0].name
          }
        }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        dpa () {
          return this.$store.state.dpa
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []
  
          this.filter.year = this.$store.state.year
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        },
        months () {
          let numb = new Date().getMonth() + 1
          
          // this.filter.month = numb
  
          // this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })
  
          return [
            {
              text: 'Januari',
              value: 1
            },
            {
              text: 'Februari',
              value: 2
            },
            {
              text: 'Maret',
              value: 3
            },
            {
              text: 'April',
              value: 4
            },
            {
              text: 'Mei',
              value: 5
            },
            {
              text: 'Juni',
              value: 6
            },
            {
              text: 'Juli',
              value: 7
            },
            {
              text: 'Agustus',
              value: 8
            },
            {
              text: 'September',
              value: 9
            },
            {
              text: 'Oktober',
              value: 10
            },
            {
              text: 'November',
              value: 11
            },
            {
              text: 'Desember',
              value: 12
            }
          ]
        },
        // Computed untuk menentukan periode DPA
        dpaPeriods () {
          if (!this.dpa || !this.dpa.tahun) return null
          
          const murniDate = this.dpa.murni_date ? new Date(this.dpa.murni_date) : null
          const p1Date = this.dpa.p1_date ? new Date(this.dpa.p1_date) : null
          const perubahanDate = this.dpa.perubahan_date ? new Date(this.dpa.perubahan_date) : null
          
          return {
            murniStart: murniDate,
            murniEnd: p1Date || perubahanDate,
            p1Start: p1Date,
            p1End: perubahanDate,
            perubahanStart: perubahanDate
          }
        },
        // Menentukan apakah bulan yang dipilih dalam periode tertentu
        isInMurniPeriod () {
          if (!this.dpaPeriods || !this.dpaPeriods.murniStart) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
          const murniEnd = this.dpaPeriods.murniEnd ? new Date(this.dpaPeriods.murniEnd.getFullYear(), this.dpaPeriods.murniEnd.getMonth(), 1) : null
          
          return selectedDate >= murniStart && (!murniEnd || selectedDate < murniEnd)
        },
        isInP1Period () {
          if (!this.dpaPeriods || !this.dpaPeriods.p1Start) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
          const p1End = this.dpaPeriods.p1End ? new Date(this.dpaPeriods.p1End.getFullYear(), this.dpaPeriods.p1End.getMonth(), 1) : null
          
          return selectedDate >= p1Start && (!p1End || selectedDate < p1End)
        },
        isInPerubahanPeriod () {
          if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
          
          return selectedDate >= perubahanStart
        }
      },
      mounted () {
        this.fetchDpa()
        // this.fetchUnitKecamatan()
        
      },
      methods: {
        getDpaStatus () {
          // Jika dalam periode perubahan, gunakan 'perubahan'
          if (this.isInPerubahanPeriod) {
            return 'perubahan'
          }
          
          // Jika dalam periode P1, gunakan 'p1'
          if (this.isInP1Period) {
            return 'p1'
          }
          
          // Jika dalam periode murni, gunakan 'murni'
          if (this.isInMurniPeriod) {
            return 'murni'
          }
          
          // Jika bulan yang dipilih sebelum periode perubahan dan ada filter.dpa, gunakan filter.dpa
          if (this.dpa && this.dpa.perubahan_date && new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)) {
            return this.filter.dpa || 'murni'
          }
          
          // Default ke 'perubahan'
          return 'perubahan'
        },
        async fetchDpa () {
          let params = {
            tahun:  this.filter.year
          }
          await get('admin/dpa/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
  
              TokenService.saveDpa(JSON.stringify(res.results.data[0]))
  
              this.$store.commit("setDpa", res.results.data[0])
              
              this.fetch()
              
            }
          })
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = Number(value)
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'month_year') {
            data = value.length > 0 ? moment(value).format('MMM, YYYY') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetchMurni ( pagination = { row: 2000000000000000, page: 1 } ) {
          let params = {
            limit: pagination.row,
            page: pagination.page,
            // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
  
            // sekda: this.filter.type === 'Sekda' ? 'ya' : '',
            // kecamatan_id : this.filter.kecamatan_id,›
            // unit_id: this.filter.unit_id,
            // unit_asisten: this.filter.asistensi,
            // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
            // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',
  
            tahun_anggaran: this.filter.year,
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: this.filter.month,
            dpa_status: 'murni'
          }
          await get(`admin/report/summary_opd_public`, { params })
          .then(response => {
            let res = response.data
            if (res.status === 200) {
              this.listMurni = res.results.data
              this.detailMurni = res.results
            }
          })
        },

        async fetch (pagination = { row: 2000000000000000, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
  
            // sekda: this.filter.type === 'Sekda' ? 'ya' : '',
            // kecamatan_id : this.filter.kecamatan_id,›
            // unit_id: this.filter.unit_id,
            // unit_asisten: this.filter.asistensi,
            // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
            // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',
  
            tahun_anggaran: this.filter.year,
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: this.filter.month,
            dpa_status: this.getDpaStatus()
          }
  
          this.selected.row = []
  
          await get(`admin/report/summary_opd_public`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                {
                  text: 'Unit',
                  width: '400px',
                  value: 'unit_name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'Asisten',
                  width: '400px',
                  value: 'unit_asisten',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Nominal Anggaran',
                  width: '200px',
                  value: 'total_anggaran',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Nominal Anggaran Perubahan',
                  width: '300px',
                  value: 'total_anggaran_perubahan',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Tahun Anggaran',
                  width: '200px',
                  value: 'tahun_anggaran',
                  freeze: false,
                  hide: false,
                  align: 'center'
                },
                {
                  text: 'Target Fisik',
                  width: '200px',
                  value: 'total_target_fisik',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'Target Keuangan',
                  width: '200px',
                  value: 'total_target_keu',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Realisasi Fisik',
                  width: '200px',
                  value: 'total_realisasi_fisik',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'Realisasi Keuangan',
                  width: '200px',
                  value: 'total_realisasi_keu',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Deviasi',
                  width: '200px',
                  value: 'deviasi',
                  freeze: false,
                  hide: false,
                  align: 'center'
                },
                {
                  text: 'SP2D (%)',
                  width: '200px',
                  value: 'persentase_sp2d',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'SP2D (Anggaran)',
                  width: '200px',
                  value: 'persentase_sp2d_anggaran',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                }
              ]
  
              this.list = res.results.data
              this.detail = res.results
              this.fetchMurni()
              // this.pagination = res.results.pagination
              
              // this.list = this.changeData(res.results.data)
              console.log(this.list.length)
              this.pagination = {
                total_data: res.results.data.length,
                total_page: 1,
                total_display: res.results.data.length,
                first_page: false,
                last_page: false,
                prev: 0,
                current: 1,
                next: 0,
                detail: [],
                start: 1,
                end: 10
              }
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        changeData (data_array) {
          function filter (array, condition) {
            let result = []
  
            for (let i = 0; i < array.length; i++) {
              if (condition(array[i])) {
                result.push(array[i])
              }
            }
  
            return result
          }
  
          function getChilds (parentKey, items) {
            let subItems = filter(items, function (n) {
              return n.par_id === parentKey
            })
  
            let result = []
  
            for (let i = 0; i < subItems.length; i++) {
              let subItem = subItems[i]
  
              let kids = getChilds(subItem.id, items)
              if (kids.length) {
                subItem.children = kids
              }
  
              result.push(subItem)
            }
  
            if (parentKey.length) {
              return result
            } else {
              return result[0]
            }
          }
  
          const data = data_array
  
          let richMediaData = getChilds('0', data)
  
          return richMediaData
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        // FILTER
        async fetchUnit () {
          let params = {
            limit: 100000,
            year: new Date().getFullYear()
          }
  
          await get('admin/unit/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.filter_data.unit = res.results.data
            }
          })
        },
  
        async fetchUnitKecamatan () {
          let params = {
            limit: 100000,
            type: 'Kecamatan',
            year: new Date().getFullYear()
          }
  
          await get('admin/unit/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.filter_data.kecamatan = res.results.data
            }
          })
        },
  
        // EXPORT
        formatExportPrice (num) {
          const data = Number(num)
          if (isNaN(data)) return 'Rp 0'
          return `Rp ${data.toLocaleString('id-ID')}`
        },

        escapeExportHtml (value) {
          return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
        },

        getExportFileName () {
          const date = moment().format('YYYY-MM-DD')
          return `EXPORT-ALL-OPD-PERKEMBANGAN-FISIK-DAN-KEUANGAN-TAHUN-ANGGARAN-${this.filter.year}-${date}`
        },

        showExportSnackbar (successText) {
          this.message.error = ''
          this.message.success = successText
          this.dialog.snackbar = true
        },

        showExportError (errorText) {
          this.message.success = ''
          this.message.error = errorText
          this.dialog.snackbar = true
        },

        normalizeExportList (data) {
          if (Array.isArray(data)) return data
          if (data && typeof data === 'object') return Object.values(data)
          return []
        },

        getExportList () {
          return this.normalizeExportList(this.list)
        },

        getExportHeaderLabels () {
          return [
            'OPD',
            'Anggaran Murni',
            'Anggaran P1',
            'Anggaran Perubahan',
            'Realisasi %',
            'Target %',
            'Deviasi %',
            'Anggaran Kas Perbulan ( Rp )',
            'Persentase SP2D terhadap Pagu Anggaran',
            'Realisasi Keuangan/SP2D (Rp)',
            'Persentase SP2D terhadap Kas Perbulan'
          ]
        },

        isExportCenterColumn (colIndex) {
          return colIndex === 8 || colIndex === 10
        },

        getExportCellAlign (colIndex) {
          if (this.isExportCenterColumn(colIndex)) return 'center'
          if ([1, 2, 3, 7, 9].includes(colIndex)) return 'right'
          return 'left'
        },

        calcExportColumnWidths (rows, forPdf = false, doc = null) {
          const labels = this.getExportHeaderLabels()
          const charCounts = labels.map((label, colIndex) => {
            let max = String(label).length
            rows.forEach(row => {
              const len = String(row[colIndex] != null ? row[colIndex] : '').length
              if (len > max) max = len
            })
            return max
          })

          if (forPdf && doc) {
            const pageWidth = doc.internal.pageSize.getWidth() - 20
            let mmWidths = charCounts.map(count => Math.max(count * 1.15 + 6, 10))
            const total = mmWidths.reduce((sum, w) => sum + w, 0)
            if (total > pageWidth) {
              const scale = pageWidth / total
              mmWidths = mmWidths.map(w => Math.max(w * scale, 8))
            }
            return mmWidths
          }

          return charCounts.map(count => Math.max(count * 7 + 20, 40))
        },

        getExportRows () {
          const list = this.getExportList()
          const listMurni = this.normalizeExportList(this.listMurni)
          const rows = list.map((item, index) => {
            const murniItem = listMurni[index] || {}
            return [
            item.unit_name || '',
            this.formatExportPrice(murniItem.total_anggaran != null ? murniItem.total_anggaran : 0),
            this.formatExportPrice(item.total_anggaran_p1),
            this.formatExportPrice(item.total_anggaran_perubahan),
            item.total_realisasi_fisik ?? '',
            item.total_target_fisik ?? '',
            item.deviasi ?? '',
            this.formatExportPrice(item.total_target_keu),
            item.persentase_sp2d ?? '',
            this.formatExportPrice(item.total_realisasi_keu),
            item.persentase_sp2d_anggaran != null ? item.persentase_sp2d_anggaran : ''
            ]
          })

          if (Object.keys(this.detail).length > 0) {
            rows.push([
              'Jumlah',
              this.formatExportPrice(this.detailMurni && this.detailMurni.grand_total_anggaran != null ? this.detailMurni.grand_total_anggaran : 0),
              this.formatExportPrice(this.detail.grand_total_anggaran_p1),
              this.formatExportPrice(this.detail.grand_total_anggaran_perubahan),
              this.detail.grand_total_realisasi_fisik ?? '',
              this.detail.grand_total_total_target_fisik ?? '',
              this.detail.grand_total_deviasi ?? '',
              this.formatExportPrice(this.detail.grand_total_target_keuangan),
              this.detail.grand_total_persentase_sp2d ?? '',
              this.formatExportPrice(this.detail.total_realisasi_keuangan),
              this.detail.grand_total_persentase_sp2d_anggaran ?? ''
            ])
          }

          return rows
        },

        buildExportTableHtml () {
          const rows = this.getExportRows()
          const colWidths = this.calcExportColumnWidths(rows)
          const labels = this.getExportHeaderLabels()
          const cellStyle = (colIndex) => {
            const align = this.getExportCellAlign(colIndex)
            return `style="text-align: ${align}; white-space: nowrap; min-width: ${colWidths[colIndex]}px; width: ${colWidths[colIndex]}px;"`
          }

          let tableHtml = '<table border="1" cellspacing="0" cellpadding="4" style="border-collapse: collapse; table-layout: auto; width: auto;">'
          tableHtml += '<colgroup>'
          colWidths.forEach((width) => {
            tableHtml += `<col style="min-width: ${width}px; width: ${width}px;">`
          })
          tableHtml += '</colgroup>'
          tableHtml += '<tr>'
          tableHtml += `<th rowspan="2" ${cellStyle(0)}>${this.escapeExportHtml(labels[0])}</th>`
          tableHtml += `<th rowspan="2" ${cellStyle(1)}>${this.escapeExportHtml(labels[1])}</th>`
          tableHtml += `<th rowspan="2" ${cellStyle(2)}>${this.escapeExportHtml(labels[2])}</th>`
          tableHtml += `<th rowspan="2" ${cellStyle(3)}>${this.escapeExportHtml(labels[3])}</th>`
          tableHtml += '<th colspan="3" style="text-align: center;">Perkembangan Fisik</th>'
          tableHtml += '<th colspan="4" style="text-align: center;">Perkembangan Keuangan</th>'
          tableHtml += '</tr>'
          tableHtml += '<tr>'
          for (let i = 4; i <= 10; i++) {
            tableHtml += `<th ${cellStyle(i)}>${this.escapeExportHtml(labels[i])}</th>`
          }
          tableHtml += '</tr>'

          rows.forEach((row) => {
            tableHtml += '<tr>'
            row.forEach((cell, colIndex) => {
              tableHtml += `<td ${cellStyle(colIndex)}>${this.escapeExportHtml(cell)}</td>`
            })
            tableHtml += '</tr>'
          })

          tableHtml += '</table>'
          return tableHtml
        },

        downloadExportFile (blob, fileName) {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName)
            return
          }

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.download = fileName
          document.body.appendChild(link)
          link.click()

          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }, 200)
        },

        exportsExcel () {
          this.message.error = ''

          if (this.getExportList().length === 0) {
            this.showExportError('Data belum tersedia, silahkan tunggu data selesai dimuat')
            return
          }

          this.process.exportExcel = true

          try {
            const XLSX = require('xlsx-js-style')
            const labels = this.getExportHeaderLabels()
            const list = this.getExportList()
            const listMurni = this.normalizeExportList(this.listMurni)
            const titleRowCount = 3
            const gapRowCount = 1
            const headerRowCount = 2
            const dataStartRow = titleRowCount + gapRowCount + headerRowCount
            const currencyCols = [1, 2, 3, 7, 9]
            const percentCols = [4, 5, 6, 8, 10]
            const currencyFmt = '#,##0.00'
            const percentFmt = '0.00"%"'
            const plainNumFmt = '0.00'

            const thinBorder = {
              top: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } }
            }

            const headerStyle = {
              fill: { fgColor: { rgb: 'FFFFFF' } },
              font: { bold: true },
              alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
              border: thinBorder
            }

            const toNumber = (val) => {
              if (val === '' || val === null || val === undefined) return 0
              if (typeof val === 'number') return isNaN(val) ? 0 : val
              let str = String(val).trim()
              if (str.includes(',')) {
                str = str.replace(/\./g, '').replace(',', '.')
              }
              const num = Number(str)
              return isNaN(num) ? 0 : num
            }

            const setCell = (ws, r, c, value, style) => {
              const ref = XLSX.utils.encode_cell({ r, c })
              const cell = { v: value, t: typeof value === 'number' ? 'n' : 's' }
              if (style) cell.s = style
              ws[ref] = cell
            }

            const setNumberCell = (ws, r, c, value, numFmt, extraStyle) => {
              const ref = XLSX.utils.encode_cell({ r, c })
              ws[ref] = {
                v: toNumber(value),
                t: 'n',
                z: numFmt,
                s: Object.assign({ border: thinBorder }, extraStyle || {})
              }
            }

            const ws = {}
            const totalCols = labels.length

            setCell(ws, 0, 0, 'Rekapitulasi OPD Publik')
            setCell(ws, 1, 0, `TAHUN ANGGARAN: ${this.filter.year}`)
            setCell(ws, 2, 0, `SAMPAI DENGAN BULAN: ${this.filter.month_text}`)

            const headerRow1 = titleRowCount + gapRowCount
            const headerRow2 = headerRow1 + 1

            setCell(ws, headerRow1, 0, labels[0], headerStyle)
            setCell(ws, headerRow1, 1, labels[1], headerStyle)
            setCell(ws, headerRow1, 2, labels[2], headerStyle)
            setCell(ws, headerRow1, 3, labels[3], headerStyle)
            setCell(ws, headerRow1, 4, 'Perkembangan Fisik', headerStyle)
            setCell(ws, headerRow1, 7, 'Perkembangan Keuangan', headerStyle)

            for (let i = 4; i <= 10; i++) {
              setCell(ws, headerRow2, i, labels[i], headerStyle)
            }

            const dataRows = list.map((item, index) => {
              const murniItem = listMurni[index] || {}
              return [
                item.unit_name || '',
                murniItem.total_anggaran != null ? murniItem.total_anggaran : 0,
                item.total_anggaran_p1,
                item.total_anggaran_perubahan,
                item.total_realisasi_fisik,
                item.total_target_fisik,
                item.deviasi,
                item.total_target_keu,
                item.persentase_sp2d,
                item.total_realisasi_keu,
                item.persentase_sp2d_anggaran != null ? item.persentase_sp2d_anggaran : ''
              ]
            })

            if (dataRows.length > 0 && Object.keys(this.detail).length > 0) {
              dataRows.push([
                'Jumlah',
                this.detailMurni && this.detailMurni.grand_total_anggaran != null ? this.detailMurni.grand_total_anggaran : 0,
                this.detail.grand_total_anggaran_p1,
                this.detail.grand_total_anggaran_perubahan,
                this.detail.grand_total_realisasi_fisik,
                this.detail.grand_total_total_target_fisik,
                this.detail.grand_total_deviasi,
                this.detail.grand_total_target_keuangan,
                this.detail.grand_total_persentase_sp2d,
                this.detail.total_realisasi_keuangan,
                this.detail.grand_total_persentase_sp2d_anggaran
              ])
            }

            const totalRowIndex = dataRows.length - 1
            const hasTotalRow = dataRows.length > 1 && Object.keys(this.detail).length > 0

            dataRows.forEach((row, rowIndex) => {
              const r = dataStartRow + rowIndex
              const isTotalRow = hasTotalRow && rowIndex === totalRowIndex
              const rowBold = isTotalRow ? { font: { bold: true } } : {}

              row.forEach((value, c) => {
                if (isTotalRow) {
                  if (c === 0) {
                    setCell(ws, r, c, value, Object.assign({ border: thinBorder, alignment: { horizontal: 'center' } }, rowBold))
                  } else if (currencyCols.includes(c)) {
                    setNumberCell(ws, r, c, value, currencyFmt, Object.assign({ alignment: { horizontal: 'right' } }, rowBold))
                  } else if (percentCols.includes(c)) {
                    if (value === '' || value === null || value === undefined) {
                      setCell(ws, r, c, '', Object.assign({ border: thinBorder, alignment: { horizontal: 'center' } }, rowBold))
                    } else {
                      setNumberCell(ws, r, c, value, plainNumFmt, Object.assign({ alignment: { horizontal: 'center' } }, rowBold))
                    }
                  } else {
                    setCell(ws, r, c, value, Object.assign({ border: thinBorder }, rowBold))
                  }
                  return
                }

                if (currencyCols.includes(c)) {
                  setNumberCell(ws, r, c, value, currencyFmt, Object.assign({ alignment: { horizontal: 'right' } }, rowBold))
                } else if (percentCols.includes(c)) {
                  setNumberCell(ws, r, c, value, percentFmt, Object.assign({ alignment: { horizontal: 'center' } }, rowBold))
                } else if (c === 0) {
                  setCell(ws, r, c, value, Object.assign({ border: thinBorder, alignment: { horizontal: 'left', wrapText: true } }, rowBold))
                } else {
                  setCell(ws, r, c, value, Object.assign({ border: thinBorder }, rowBold))
                }
              })
            })

            const lastRow = dataStartRow + dataRows.length - 1
            ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: lastRow, c: totalCols - 1 } })
            ws['!merges'] = [
              { s: { r: headerRow1, c: 0 }, e: { r: headerRow2, c: 0 } },
              { s: { r: headerRow1, c: 1 }, e: { r: headerRow2, c: 1 } },
              { s: { r: headerRow1, c: 2 }, e: { r: headerRow2, c: 2 } },
              { s: { r: headerRow1, c: 3 }, e: { r: headerRow2, c: 3 } },
              { s: { r: headerRow1, c: 4 }, e: { r: headerRow1, c: 6 } },
              { s: { r: headerRow1, c: 7 }, e: { r: headerRow1, c: 10 } }
            ]
            ws['!views'] = [{
              state: 'frozen',
              xSplit: 1,
              ySplit: dataStartRow,
              topLeftCell: XLSX.utils.encode_cell({ r: dataStartRow, c: 1 }),
              activeCell: XLSX.utils.encode_cell({ r: dataStartRow, c: 1 })
            }]

            const colWidths = []
            for (let c = 0; c < totalCols; c++) {
              let maxLen = 10
              for (let r = 0; r <= lastRow; r++) {
                const ref = XLSX.utils.encode_cell({ r, c })
                const cell = ws[ref]
                if (!cell || cell.v == null) continue
                let display = String(cell.v)
                if (cell.t === 'n' && cell.z === currencyFmt) {
                  display = toNumber(cell.v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                } else if (cell.t === 'n' && cell.z === percentFmt) {
                  display = `${toNumber(cell.v).toFixed(2)}%`
                }
                maxLen = Math.max(maxLen, display.length)
              }
              colWidths.push({ wch: maxLen + 2 })
            }
            ws['!cols'] = colWidths

            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Rekap OPD Publik')
            XLSX.writeFile(wb, `${this.getExportFileName()}.xlsx`)

            this.showExportSnackbar('Berhasil mengeksport Excel')
          } catch (error) {
            console.error('Export Excel error:', error)
            this.showExportError('Gagal mengeksport Excel')
          } finally {
            this.process.exportExcel = false
          }
        },

        exports () {
          this.message.error = ''

          if (this.getExportList().length === 0) {
            this.showExportError('Data belum tersedia, silahkan tunggu data selesai dimuat')
            return
          }

          this.process.export = true

          try {
            generateRekapOpdPublicPdf({
              fileName: `${this.getExportFileName()}.pdf`,
              year: this.filter.year,
              monthText: this.filter.month_text,
              list: this.list,
              listMurni: this.listMurni,
              detail: this.detail,
              detailMurni: this.detailMurni
            })
            this.showExportSnackbar('Berhasil mengeksport pdf')
          } catch (error) {
            console.error('Export PDF error:', error)
            this.showExportError('Gagal mengeksport pdf')
          } finally {
            this.process.export = false
          }
        }
      }
    }
  </script>
  
  
  <style>
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      width: 100%;
    }
  
    .wrapper {
      /* position: relative;
      overflow: auto;
      white-space: nowrap; */
    }
  
    .wrapper th {
        /* background: #04a8bf5e; */
    }
  
    .wrapper { 
      overflow-y: auto; 
      height: calc(100vh - 260px); 
    } 
    .wrapper th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
  
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 350px;
      min-width: 350px;
      max-width: 350px;
      left: 0px;
    }
  
    .second-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 150px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
  </style>